export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Final2_10.54ca3c34.jpg";